import { useState, useEffect } from "react";

interface Return {
  width?: number;
  height?: number;
}

const useWindowResize = (): Return => {
  const isClient = typeof window === "object";

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    function handleResize() {
      setWindowSize(getSize());
    }

    if (isClient) {
      window.addEventListener("resize", handleResize);
    }

    return () => window.removeEventListener("resize", handleResize); // invoked on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // force empty array so we only run on mount / unmount

  return windowSize;
};

export default useWindowResize;
